import React from 'react';
import { FileTextIcon } from 'lucide-react';
interface PagesPillProps {
  pages: string;
  className?: string;
}
export function PagesPill({
  pages,
  className = ''
}: PagesPillProps) {
  return <span className={`inline-flex w-fit items-center gap-1 whitespace-nowrap rounded-full border border-gold px-2.5 py-0.5 text-xs font-medium text-gold ${className}`} data-id="element-129" data-mp="1svt7bb2cl6g6">
      <FileTextIcon className="h-3 w-3 shrink-0" aria-hidden="true" data-id="element-130" data-mp="1juv42uzqh2yn" />
      {pages}
    </span>;
}